import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  OnInit,
  ViewChild,
} from '@angular/core';
import { Router } from '@angular/router';
import { UntypedFormControl } from '@angular/forms';
import { OrganizationsService } from '../../services/organizations.service';
import { AuthService } from '../../services/auth.service';
import { Observable } from 'rxjs';
import { Organization } from '../../types/organization.type';
import { PopupService } from '../../services/popup.service';

@Component({
  selector: 'app-organization',
  templateUrl: './organization.component.html',
  styleUrls: ['./organization.component.scss'],
})
export class OrganizationComponent implements OnInit {
  @Input() organization: Organization;
  @Input() wide = false;
  followControl = new UntypedFormControl(false);

  public user$ = this.authService.user$;

  @ViewChild('unauthorizedUserPopup', { static: true })
  unauthorizedUserPopup: ElementRef;

  constructor(
    private router: Router,
    private authService: AuthService,
    private cdr: ChangeDetectorRef,
    private popupService: PopupService,
    private organizationsService: OrganizationsService
  ) {}

  ngOnInit(): void {
    this.followControl.valueChanges.subscribe(() => {
      if (this.authService.user) {
        this.toggleFollow().subscribe();
      } else {
        this.openUnauthorizedUserPopup();
        this.followControl.setValue(false, {
          emitEvent: false,
        });
      }
    });

    this.user$.subscribe((user) => {
      this.followControl.setValue(
        Boolean(
          user?.follows.organizations.find(
            (org) => org.organization_id === this.organization.organization_id
          )
        ),
        { emitEvent: false }
      );
      this.cdr.detectChanges();
    });
  }

  navigate(): void {
    this.router.navigate(['/results'], {
      queryParams: {
        organization_id: this.organization.organization_id,
      },
    });
  }

  toggleFollow(): Observable<Object> {
    return this.organizationsService.followOrganization(
      this.organization.organization_id
    );
  }

  openUnauthorizedUserPopup(): void {
    this.popupService.showPopup(this.unauthorizedUserPopup);
  }
}
